import useFetch from '../../../_fetch'
import { getColumns } from './columns'
import { Table } from '../_table/table'

export default function PublisherReport() {        
    const { doFetch } = useFetch()
    const columns = getColumns()
    
    return (
        <Table 
            columns={columns} 
            getData={async (fromDate, toDate) => {
                const res = await doFetch('/data/total-transactions-by-affiliate', {
                    fromDate, toDate, timezoneOffsetMinutes: new Date().getTimezoneOffset()
                })
                if (!res.ok) throw new Error('Publisher performance could not be fetched for the selected period.')

                const data = await res.json()
                if (!Array.isArray(data)) throw new Error('The server returned an unexpected publisher report format.')
                
                for(const d of data) {
                    d.conversionRate = d.totalClicks ? d.totalTransactions / d.totalClicks * 100 : 0
                    d.roas = d.totalCommission ? d.totalOrderAmount / d.totalCommission : 0
                    d.cpc = d.totalClicks ? d.totalCommission / d.totalClicks : 0
                    d.epc = d.totalClicks ? d.totalOrderAmount / d.totalClicks : 0
                }

                return data
            }}
            title='Publisher Report'
            description='Evaluate publisher traffic, conversion quality, revenue, and efficiency in one place.'
            entityLabel='publishers'
            pageKey='publisher-report'
            defaultSort='totalOrderAmount'
        />)
}
